<template>
  <div class="ext">
    <div ref="chartDom" class="echarts-dom" :style="chartWrapStyle"></div>
  </div>
</template>

<script>
export default {
  props: {
    message: [Object, Array],
    /** 手机端紧凑布局：容器宽度 100%，避免固定 1400px 撑破弹窗 */
    compact: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      shiduanshunshiliuliang: null,
      shiduanyali: null,
      time_points: null,
      chartInstance: null
    }
  },
  computed: {
    chartWrapStyle () {
      if (this.compact) {
        return {
          width: '100%',
          height: '260px',
          minHeight: '220px',
          boxSizing: 'border-box'
        }
      }
      return { width: '1400px', height: '240px' }
    }
  },
  watch: {
    message (new1, new2) {
      console.log(new1, '1', new2)
      this.shiduanshunshiliuliang = new1.shiduanshunshiliuliang
      this.shiduanyali = new1.shiduanyali
      this.time_points = new1.time_points
      this.drawLine()
    },
    compact () {
      this.$nextTick(() => this.drawLine())
    }
  },
  created () {
    console.log(this.message, '121')
  },
  mounted () {
    this.drawLine()
  },
  beforeDestroy () {
    if (this.chartInstance) {
      try {
        this.chartInstance.dispose()
      } catch (e) {}
      this.chartInstance = null
    }
  },

  methods: {
    drawLine () {
      console.log(this.shiduanshunshiliuliang, 'shiduanshunshiliuliang')
      const el = this.$refs.chartDom
      if (!el) return
      if (this.chartInstance) {
        try {
          this.chartInstance.dispose()
        } catch (e) {}
        this.chartInstance = null
      }
      this.chartInstance = this.$echarts.init(el)
      
      // 定义左右轴颜色
      const leftAxisColor = '#5470c6';
      const rightAxisColor = '#91cc75';
      
      this.chartInstance.setOption({
        title: {
          subtext: '时段瞬时流量/时段压力',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderWidth: 1,
          borderColor: '#ddd',
          padding: [10, 15],
          textStyle: {
            color: '#333'
          },
          formatter: function(params) {
            let time = params[0].name;
            let result = `<div style="font-weight: bold; margin-bottom: 8px; color: #333;">${time}</div>`;
            params.forEach(param => {
              let unit = param.seriesName === '瞬时流量' ? ' m³/h' : ' MPa';
              let axisLabel = param.seriesName === '瞬时流量' ? '（左轴）' : '（右轴）';
              result += `
                <div style="display: flex; align-items: center; margin: 4px 0;">
                  <span style="display: inline-block; width: 10px; height: 10px; 
                           background-color: ${param.color}; border-radius: 50%; margin-right: 8px;"></span>
                  <span>${param.seriesName}${axisLabel}: <b>${param.value}</b>${unit}</span>
                </div>
              `;
            });
            return result;
          }
        },
        legend: {
          data: ['瞬时流量', '压力'],
          bottom: 10
        },
        toolbox: {
          show: true,
          feature: {
            restore: {},
            saveAsImage: {}
          },
          right: 20
        },
        grid: {
          left: 60,
          right: 60,
          top: 50,
          bottom: 60
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.time_points,
          axisPointer: {
            snap: true
          }
        },
        yAxis: [
          {
            // 左侧Y轴 - 瞬时流量
            type: 'value',
            name: '瞬时流量 (m³/h)',
            nameTextStyle: {
              color: leftAxisColor,
              fontWeight: 'bold'
            },
            position: 'left',
            axisLine: {
              show: true,
              lineStyle: {
                color: leftAxisColor
              }
            },
            axisLabel: {
              formatter: '{value}',
              color: leftAxisColor
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#e0e0e0'
              }
            }
          },
          {
            // 右侧Y轴 - 压力
            type: 'value',
            name: '压力 (MPa)',
            nameTextStyle: {
              color: rightAxisColor,
              fontWeight: 'bold'
            },
            position: 'right',
            axisLine: {
              show: true,
              lineStyle: {
                color: rightAxisColor
              }
            },
            axisLabel: {
              formatter: '{value}',
              color: rightAxisColor
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '瞬时流量',
            type: 'line',
            smooth: true,
            data: this.shiduanshunshiliuliang,
            yAxisIndex: 0, // 对应左侧Y轴
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: leftAxisColor
            },
            lineStyle: {
              width: 3
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(84, 112, 198, 0.5)'
                }, {
                  offset: 1, color: 'rgba(84, 112, 198, 0.1)'
                }]
              }
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                borderWidth: 2,
                borderColor: '#fff',
                shadowBlur: 10,
                shadowColor: 'rgba(84, 112, 198, 0.8)'
              }
            }
          },
          {
            name: '压力',
            type: 'line',
            smooth: true,
            data: this.shiduanyali,
            yAxisIndex: 1, // 对应右侧Y轴
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: rightAxisColor
            },
            lineStyle: {
              width: 3
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                borderWidth: 2,
                borderColor: '#fff',
                shadowBlur: 10,
                shadowColor: 'rgba(145, 204, 117, 0.8)'
              }
            }
          }
        ],
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: 0,
            start: 0,
            end: 100
          }
        ]
      })
      
      this.$nextTick(() => {
        if (this.chartInstance) {
          this.chartInstance.resize()
        }
      })
    }
  }
}
</script>

<style scoped>
.ext {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}
.echarts-dom {
  max-width: 100%;
}
</style>